<!-- Main starts -->
<div role="main" class="container">
    <!-- Header starts -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <img src="assets/images/openid_logo.svg" alt="Logo OpenID">
    </nav>
    <!-- Header ends -->
    <div class="card">
        <h5 class="card-header">OpenID Login</h5>
        <div class="card-body">
            <h5 class="card-title">Accedi tramite OpenID PCKE</h5>
            <p class="card-text">Benvenuto nella home page pubblica di questa applicazione mock.</p>
           <p class="card-text">
                Cliccando sul pulsante <b>Login</b> inizierai il processo di autenticazione con il modulo di
                <b>Authentication Manager</b>
            </p>
            <p class="card-text">
                L'intero processo di autenticazione si basa su <a
                    href="https://developers.onelogin.com/openid-connect/guides/auth-flow-pkce" target="_blank">OpenID
                    PCKE</a>

            </p>
            <p class="caed-text">
                <a href="#" class="btn btn-primary" (click)="login()">Login</a>
            </p>
        </div>
    </div>
</div>